import type { CapabilityEventName, CapabilityEventProps } from "@/shared/telemetry-events.api";

/**
 * A one-way seam so the server transport can report capability events without
 * depending on telemetry.
 *
 * `postToServer` is what instruments every capability call, and telemetry sends
 * its own events through `postToServer`. Importing `trackEvent` there directly
 * would make the two modules circular. Instead this leaf holds the reporter,
 * telemetry registers itself when it loads, and the transport asks this module.
 *
 * Nothing registered means nothing reported. That is the right default: a test,
 * or a build that never loads telemetry, keeps working and stays silent rather
 * than needing a stub.
 */
export type ReportEvent = (name: CapabilityEventName, props: CapabilityEventProps) => void;

let report: ReportEvent | undefined;

export const setEventReporter = (reporter: ReportEvent): void => {
    report = reporter;
};

export const reportEvent: ReportEvent = (name, props) => {
    report?.(name, props);
};

/** Test seam: forget the registered reporter. */
export const resetEventReporterForTesting = (): void => {
    report = undefined;
};
